<script lang="ts" setup>
  defineOptions({
    name: 'll-box',
  });

  export interface BoxProps {
    /**
     * Remove the padding around the entire Box.
     */
    disablePadding?: boolean;

    /**
     * Remove the padding on the left and right of the Box.
     */
    disableGutters?: boolean;

    /**
     * Remove the padding on the left and right of the Box.
     */
    disableElevation?: boolean;

    /**
     * Border radius style. Defaults to `rounded`.
     */
    radius?: 'none' | 'rounded';
  }

  const props = withDefaults(defineProps<BoxProps>(), {
    disablePadding: false,
    disableGutters: false,
    disableElevation: false,
    radius: 'rounded',
  });
</script>

<template>
  <section
    class="stash-box bg-white"
    :class="{
      rounded: props.radius === 'rounded',
      'p-gutter': !props.disablePadding && !props.disableGutters,
      'py-gutter': props.disableGutters,
      shadow: !props.disableElevation,
    }"
    data-test="stash-box"
  >
    <!-- @slot default -->
    <slot></slot>
  </section>
</template>
